<script setup>
import { computed, watch, onBeforeUnmount, getCurrentInstance } from 'vue';
import Form from '../../common/form/Form';
import FormSaveBtn from '../../common/form/FormSaveBtn';

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const route = proxy.$route;

const tableName = 'modulecomponents';

// --- Computed ---

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === route.params.component);
});

const id = computed(() => component.value?.id);

const formId = computed(() => {
    return id.value ? `form:${tableName}:${id.value}` : null;
});

const user = computed(() => store.state.user.user);

// --- Methods ---

const initForm = () => {
    if (!id.value) return;

    // Determine which fields to show based on admin status and group
    const fieldNames = (user.value.administrator && component.value.navigationGroup !== 'Forms')
        ? [
            'title',
            'addNew',
            'updateOption',
            'deleteOption',
            'showStatus',
            'showMetadata',
            'showScheduling',
            'showDisplayOrder',
            'categoryComponent',
            'useArchive'
        ]
        : ['title'];

    store.dispatch('forms/createForm', {
        tableName: tableName,
        id: id.value,
        fieldNames: fieldNames
    });
};

// --- Watchers ---

// Watch the ID: when duplicating a form, the URL updates to the new ID.
// This watcher re-initializes the form logic for the new record.
watch(id, (newId) => {
    if (newId) {
        initForm();
    }
}, { immediate: true });

// --- Lifecycle ---

onBeforeUnmount(() => {
    if (formId.value) {
        store.unregisterModule(formId.value);
    }
});
</script>

<template>
    <div>
        <Form
            v-if="formId"
            :key="formId"
            :id="id"
            :form-id="formId"
            :show-legends="false"
        />

        <footer class="text-center mt-3 mb-3">
            <FormSaveBtn
                :button-text="'Save'"
                :cancel-on-save="true"
                :form-id="formId"
                :default-btn-class="'btn-secondary'"
            />
        </footer>
    </div>
</template>

<style scoped>
legend {
    border: none;
}

.list-group-item {
    border-color: #ebccd1;
}
</style>